import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';
import { App } from 'ionic-angular';
/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  url: string = 'https://minutiae.fr/api';
  token : string =  localStorage.getItem('token');
  private loginErrorString: string;
  private CloseButtonText: string;
  constructor(  public http: HttpClient, 
                public toastCtrl : ToastController, 
                public translateService: TranslateService,
                private app: App
              ) {
      this.translateService.get('NO_CONNEXION_ERROR','CLOSE_BUTTON_TEXT').subscribe((value) => {
        this.loginErrorString = value;
      })
    translateService.get(['NO_CONNEXION_ERROR', 'CLOSE_BUTTON_TEXT']).subscribe(values => {
      this.loginErrorString = values['NO_CONNEXION_ERROR'];
      this.CloseButtonText = values['CLOSE_BUTTON_TEXT'];
    });
  }

  get(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }

    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return this.http.get(this.url + '/' + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any) { 

    let seq = this.http.post(this.url + '/' + endpoint, body, reqOpts).share();

    seq.subscribe((res: any) => {
    //console.log(res)  // If the API returned a successful response, mark the user as logged in
           
      if(res[0]){
        if(res[0].logout=='ok'){
          this.ToastIt('Votre session est terminée, veuillez vous indentifier à nouveau');  
          localStorage.setItem('token','')
          localStorage.setItem('UserData','')
        }
      }
    }, err => {
         this.ToastIt(this.loginErrorString)
         this.app.getRootNav().setRoot('WelcomePage');
    });
    return seq;
  }

  ToastIt(msg){
          let toast = this.toastCtrl.create({
            message: msg,
            duration: 5000,
            position: 'middle',
            showCloseButton : true,
            closeButtonText : this.CloseButtonText
          });
          toast.present();
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + '/' + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this.http.delete(this.url + '/' + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.http.patch(this.url + '/' + endpoint, body, reqOpts);
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts